import React, { useEffect, useState } from "react";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className={`site-header ${scrolled ? "scrolled" : ""}`}>
      <a href="#about" className="header-logo">Farha Lina</a>
      <nav>
        <ul className="header-nav">
          <li><a href="#about">About</a></li>
          <li><a href="#projects">Experience</a></li>
          <li><a href="#contact">Contact</a></li>
          <li>
            <a
              href="/Farha_Lina_Resume.pdf"
              download="Farha_Lina_Resume.pdf"
              className="header-resume-btn"
            >
              Resume
            </a>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
